import { Component, Input, OnInit } from '@angular/core';
import { RWDService } from 'src/app/view/user-context/services/rwd.service';
import { LocLabel } from '../clickable-row-table/models/data-table-config.models';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnInit {
  @Input() tooltipKey: string | LocLabel | null | undefined;
  @Input() icon: string = 'help';
  @Input() color: 'primary' | 'white' = 'primary';

  constructor(public rwdService: RWDService) {}

  ngOnInit() {}
}
